import {getAllCustomersPersonObject} from "../../pages/Customers/functions";
import {getAllStoragemanObject} from "../../pages/Storageman/functions";
import {getAllDriversObject} from "../../pages/Drivers/functions";
import { getAllManagersPersonObject} from "../../pages/Managers/functions";

export const getAllPeopleDividedByRole = async () => {
    const allCustomersObject = await getAllCustomersPersonObject();
    const allManagerObject = await getAllManagersPersonObject();
    const allStoragemanObject = await getAllStoragemanObject();
    const allDriversObject = await getAllDriversObject();

    for (let i = 0; i < allCustomersObject.length; i++)
        allCustomersObject[i].parentId = "customer";
    for (let i = 0; i < allManagerObject.length; i++)
        allManagerObject[i].parentId = "manager";
    for (let i = 0; i < allStoragemanObject.length; i++)
        allStoragemanObject[i].parentId = "storageman";
    for (let i = 0; i < allDriversObject.length; i++)
        allDriversObject[i].parentId = "driver";


    const people = [
        ...allCustomersObject    ,
        ...allManagerObject ,
        ...allStoragemanObject ,
         ...allDriversObject,
        {
            label : "مشتری" ,
            value : "customer",
            id : "customer",
            parentId : null
        },
        {
            label : "راننده" ,
            value : "driver",
            id : "driver",
            parentId : null
        },{
            label : "انباردار" ,
            value : "storageman",
            id : "storageman",
            parentId : null
        },
        {
            label : "مدیر" ,
            value : "manager",
            id : "manager",
            parentId : null
        }
    ]
    return people;

}